import React, { useEffect } from 'react';
import { PortalOverlay } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { useSelector } from 'react-redux';
import { UI } from '@leverege/ui-redux';
import S from './DataViewerWrapper.css';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataViewerWrapper(props) {
  const {
    Component,
    ...rest
  } = props;
  const {
    onFilterChange,
    filterName,
    forwardRef,
    dataViewerId
  } = props;
  useEffect(() => {
    return () => {
      onFilterChange?.({
        data: filterName,
        value: null,
        isOnUnmount: true
      });
    };
  }, []);
  const expanded = useSelector(state => UI.get(state, 'expanded'));
  const showExpanded = expanded && expanded?.context?.clientProps?.dataViewerId === dataViewerId;
  const content = /*#__PURE__*/_jsx(Component, {
    ...rest,
    ref: forwardRef,
    onFilterChange: onFilterChange,
    filterName: filterName,
    dataViewerId: dataViewerId
  });
  if (showExpanded && !expanded?.context?.clientProps?.dataViewerCardModel) {
    return /*#__PURE__*/_jsx(PortalOverlay, {
      targetId: Config.get('expandedViewer', 'targetPortalId', 'expandedContainer'),
      show: true,
      showBackground: false,
      className: S.expandedViewer,
      variant: "expandedViewer",
      animation: "fade",
      children: /*#__PURE__*/_jsx("div", {
        children: content
      })
    });
  }
  return content;
}